import { Outlet } from "react-router";
import CacheBuster from "./CacheBuster";

const CacheBusterContainer = () => {
  return (
    <>
      <CacheBuster />
      <Outlet />
    </>
  );
};

export default CacheBusterContainer;
